import {
  getMerchantReport,
  postCreateReport,
  downloadReport,
  getMerchantSummary
  } from "../../services/MerchantReportServices";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const MERCHANT_REPORT_INITIATED = "MERCHANT_REPORT_INITIATED";
  export const MERCHANT_REPORT_LOADED = "MERCHANT_REPORT_LOADED";
  export const MERCHANT_REPORT_FAILED = "MERCHANT_REPORT_FAILED";
  export const MERCHANT_SUMMARY_INITIATED = "MERCHANT_SUMMARY_INITIATED";
  export const MERCHANT_SUMMARY_LOADED = "MERCHANT_SUMMARY_LOADED";
  export const MERCHANT_SUMMARY_FAILED = "MERCHANT_SUMMARY_FAILED";
  export const MERCHANT_REPORT_GENERATE_INITIATED = "MERCHANT_REPORT_GENERATE_INITIATED";
  export const MERCHANT_REPORT_GENERATE_LOADED = "MERCHANT_REPORT_GENERATE_LOADED";
  export const MERCHANT_REPORT_GENERATE_FAILED = "MERCHANT_REPORT_GENERATE_FAILED";
  export const MERCHANT_DOWNLOAD_INITIATED = "MERCHANT_DOWNLOAD_INITIATED";
  export const MERCHANT_DOWNLOAD_LOADED = "MERCHANT_DOWNLOAD_LOADED";
  export const MERCHANT_DOWNLOAD_FAILED = "MERCHANT_DOWNLOAD_FAILED";

  
  export const loadMerchantReport = (getData) => {
   
    return (dispatch) => {
      dispatch({ type: MERCHANT_REPORT_INITIATED });
      getMerchantReport(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_REPORT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_REPORT_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantSummary = (getData) => {
    console.log('getDatagetData', getData)
    return (dispatch) => {
      dispatch({ type: MERCHANT_SUMMARY_INITIATED });
      getMerchantSummary(getData)
        .then((response) => {
          console.log('getDatagetDataresponse', response)
          dispatch({ type: MERCHANT_SUMMARY_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_SUMMARY_FAILED, payload: error.message });
        });
    };
  };

  export const createMerchantReport = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_REPORT_GENERATE_INITIATED });
      console.log('getData', getData)
      postCreateReport(getData).then((response) => {
        formatSuccess('Report Generation', response.data)
        dispatch({ type: MERCHANT_REPORT_GENERATE_LOADED, payload: response.data });
      })
      .catch((error) => {
        if(error && error.response && error.response.data){
          dispatch({ type: MERCHANT_REPORT_GENERATE_FAILED, payload: formatError(error.response.data) });
        }
        else{
          dispatch({ type: MERCHANT_REPORT_GENERATE_FAILED, payload: formatError(error.message) });
        }
      });
    };
  };

  export const downloadMerchantReport = (getData) => {
    return async (dispatch) => {
      try {
        dispatch({ type: MERCHANT_REPORT_GENERATE_INITIATED });
        const response = await downloadReport(getData);
        const contentDisposition = response.headers['content-disposition'];
        const fileNameMatch = contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch ? fileNameMatch[1] : 'report.csv'; // fallback filename
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        dispatch({ type: MERCHANT_REPORT_GENERATE_LOADED });
      } catch (error) {
        console.error('Download error:', error);
        dispatch({
          type: MERCHANT_REPORT_GENERATE_FAILED,
          payload: error.response?.data?.message || error.message,
        });
      }
    };
  };
  